export const referralOfficeTotalLabel=(site:string)=>site==='HP'?'病院全体':site==='全事業所'?'埼玉事業所全体':`${site}全体`;
